import React from 'react'
import NavBar from '../../../features/navbar/Navbar'
import Footer from '../../../features/common/Footer'
import ProductList from '../../../features/product/components/ProductList'
import ProductMenOversized from '../../../features/productmen/components/ProductMenOversized'



const OversizedMen = () => {
  return (
    <div>
    <ProductMenOversized></ProductMenOversized>
    </div>
  )
}

export default OversizedMen
